import * as types from 'constants/actionTypes';
import initialState from './initialState';

export default function jobSummariesReducer(
  state = initialState.jobSummaries,
  action
) {
  if (action.type === types.GET_JOB_SUMMARIES_SUCCESS) {
    return {
      ...action.jobSummaries
    };
  }
  return state;
}
